import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { PERIOD_PRESET_OPTIONS } from '../../services/dashboardPeriodService';

const FilterBar = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  align-items: flex-start;

  @media (max-width: 768px) {
    width: 100%;

    label {
      width: 100%;
    }
  }
`;

const FieldLabel = styled.label`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--color-text-secondary);
`;

const StyledSelect = styled.select`
  min-width: 200px;
  max-width: 100%;
  padding: 0.45rem 0.75rem;
  border: 1px solid var(--color-border-primary);
  border-radius: 12px;
  background: var(--color-bg-primary);
  color: var(--color-text-primary);
  font-size: 0.85rem;
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
  box-shadow: var(--shadow-sm);
  transition: border-color 0.2s, box-shadow 0.2s;
  box-sizing: border-box;

  @media (max-width: 768px) {
    min-width: 0;
    width: 100%;
  }

  &:focus {
    outline: none;
    border-color: var(--color-secondary);
    box-shadow: 0 0 0 2px rgba(178, 190, 195, 0.25);
  }

  &:disabled {
    cursor: not-allowed;
    background: var(--color-bg-secondary);
    color: var(--color-text-secondary);
    box-shadow: none;
  }
`;

const DashboardPeriodFilter = ({
  value,
  onChange,
  disabled = false,
  fieldId = 'dashboard-period-filter',
}) => (
  <FilterBar>
    <FieldLabel htmlFor={fieldId}>
      Período:
      <StyledSelect
        id={fieldId}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
      >
        {PERIOD_PRESET_OPTIONS.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </StyledSelect>
    </FieldLabel>
  </FilterBar>
);

DashboardPeriodFilter.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  fieldId: PropTypes.string,
};

export default DashboardPeriodFilter;
